<template>
    <div>
      <SaleReportLabaList />
    </div>
</template>

<script>
import SaleReportLabaList from '@/components/sales/SaleReportLabaList.vue'
export default {
  name: 'SaleReportLaba',
  components: {
    SaleReportLabaList
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  }
}
</script>
